import type { BrandSpacing } from '$lib/types/Theme';

// Mirrors perspective-app-next/modules/app/editor/blocks/components/Logos/constants.ts
export const LOGO_GAP_X_PX: Record<BrandSpacing, number> = {
    xs: 4,
    sm: 8,
    md: 16,
    lg: 24,
    xl: 32,
    '2xl': 48,
    '3xl': 64,
};
